import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-post-answers',
  templateUrl: './post-answers.component.html',
  styleUrls: ['./post-answers.component.scss']
})
export class PostAnswersComponent {
commonImagePath: string = environment.commonImagePath;

  constructor(
    public dialogRef: MatDialogRef<PostAnswersComponent>
  ) { }

  closePopup(): void {
    this.dialogRef.close();
  }
}